import {defineStore} from 'pinia'
import {ErrorLocationType, ErrorType} from "@/utilities/enums/Enums";

// just used to control the error component globally
export const useErrorStore = defineStore('ErrorStore', {
    state: () => {
        return {
            text: '',
            type: ErrorType.warning,
            location: ErrorLocationType.none
        }
    },
    actions: {
        showError(text: string, type: ErrorType, location: ErrorLocationType) {
            this.text = text
            this.type = type
            this.location = location
        },
        hideError() {
            this.location = ErrorLocationType.none
        }
    }
})
